import type { Context } from './MiddlewareInterface';
import { useAuthStore } from '@/stores/useAuthStore';

export default async function authenticationMiddleware({ to }: Context) {
  const authStore = useAuthStore();
  await authStore.$persistedState.isReady();

  if (!authStore.isValidToken && !['login-module', 'Home'].includes(to.name as string)) {
    authStore.resetData();

    return { name: 'login-module', query: to.query };
  }
}
